import { useMatch, useNavigate } from 'react-router';

import { ROUTES } from '@/shared/config/routes';

/**
 * Section navigation for an IQ rail: which section the route is on, and how to
 * move between them.
 *
 * Deliberately free of the analyses list query. The redesigned rail dropped the
 * analysis selector, and `analysesQuery` polls every 10s while any analysis is
 * generating — subscribing there would keep re-rendering the rail for data it
 * never shows.
 */
export const useAnalysisSectionNav = (analysisId: string) => {
  const navigate = useNavigate();
  const match = useMatch('/iq/:analysisId/:section');

  const handleSectionClick = (sectionId: string) => {
    void navigate(ROUTES.IQ_ANALYSIS_SECTION(analysisId, sectionId));
  };

  return {
    selectedSection: match?.params.section,
    handleSectionClick,
  };
};
